<template>
  <div>
    <PageTitle :route="$route" />

    <PageRowWrapper>
      <RemoteID />
    </PageRowWrapper>

  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import RemoteID from '@/components/settings/app-frotix-registers/remoteid/Add'
import LoadingPage from '@/components/spinner/LoadingPage'

export default {
  name: 'RemoteIDView',
  components: {
    PageTitle,
    PageRowWrapper,
    RemoteID,
    LoadingPage
  }
}
</script>
